import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  sectionId: string;
};

const [useDeleteSection, deleteSection] = createAsyncAction(
  "sections/delete",
  async ({ sectionId }: Args) => {
    const res = await API.call<{ section: string }>({
      endpoint: `/sections/${sectionId}`,
      method: "PUT",
      data: { status: "deleted" },
    });
    return { ...res, result: res.result.section };
  }
);

export default useDeleteSection;
export { deleteSection };
